module.exports = __webpack_public_path__ + "img/cur12.2f25cc9e.png";